import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "./client"
import {
  ExportCalendarRequestData,
  GetCalendarBookedDatesRequestData,
  GetCalendarDatesRequestData,
  ImportCalendarRequestData,
  ResponeCalendarBookedData,
  ResponeCalendarData,
  ResponeCalendarExportData,
  ResponeCalendarImportData,
  UpdateCalendarDatesRequestData,
} from "./common"

export interface GetCalendarDatesRequest extends Partial<AxiosRequestConfig> {
  data: GetCalendarDatesRequestData
}
export interface GetCalendarDatesResponse extends AxiosResponse {
  data: ResponeCalendarData
}
export interface UpdateCalendarDatesRequest
  extends Partial<AxiosRequestConfig> {
  data: UpdateCalendarDatesRequestData
}
export interface UpdateCalendarDatesResponse extends AxiosResponse {
  data: ResponeCalendarData
}

export interface GetCalendarBookedDatesRequest
  extends Partial<AxiosRequestConfig> {
  data: GetCalendarBookedDatesRequestData
}

export interface GetCalendarBookedDatesResponse extends AxiosResponse {
  data: ResponeCalendarBookedData
}

export interface ImportCalendarRequest extends Partial<AxiosRequestConfig> {
  data: ImportCalendarRequestData
}
export interface ImportCalendarResponse extends AxiosResponse {
  data: ResponeCalendarImportData
}
export interface ExportCalendarRequest extends Partial<AxiosRequestConfig> {
  params: ExportCalendarRequestData
}
export interface ExportCalendarResponse extends AxiosResponse {
  data: ResponeCalendarExportData
}

const defaultGetDatesUrl = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/calendar/search`

export function getCalendarDates(
  { method = "post", url = defaultGetDatesUrl, ...config },
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<GetCalendarDatesResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<GetCalendarDatesResponse>
}

const defaultUpdateDatesUrl = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/calendar/save-update`

export function updateCalendarDates(
  { method = "post", url = defaultUpdateDatesUrl, ...config },
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<UpdateCalendarDatesResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<UpdateCalendarDatesResponse>
}

const defaultGetBookedDatesUrl = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/calendar/bookings`

export function getCalendarBookedDates(
  { method = "post", url = defaultGetBookedDatesUrl, ...config },
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<GetCalendarBookedDatesResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<GetCalendarBookedDatesResponse>
}

const defaultImportCalendarUrl = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/calendar/import`

export function importCalendar(
  { method = "post", url = defaultImportCalendarUrl, ...config },
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<ImportCalendarResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<ImportCalendarResponse>
}

const defaultExportCalendarUrl = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/calendar/export`

export function exportCalendar(
  {
    method = "get",
    url = defaultExportCalendarUrl,
    ...config
  }: ExportCalendarRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<ExportCalendarResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<ExportCalendarResponse>
}
